module.exports = __webpack_public_path__ + "img/zzf_board_title.93189223.png";